/** Parse the value to a number based on the language */
export const parseDecimalSeparator = (value: string, currentLang: string): string => {
  const enDecimalSeparator = '.'
  const otherDecimalSeparator = ','

  if (currentLang.includes('en')) {
    return value.replace(otherDecimalSeparator, enDecimalSeparator)
  } else {
    return value.replace(enDecimalSeparator, otherDecimalSeparator)
  }
}

/** Determine if a key press is allowed in a numeric input field, allows also negative sign at the beginning */
export const isNumericInputAllowed = (key: string, value: string, isDecimal: boolean): boolean => {
  const isNumber = /^\d+$/
  const hasMinus = value.includes('-')
  const hasDot = value.includes('.')
  const hasComma = value.includes(',')

  if (isNumber.test(key)) {
    return true
  }

  if (key === '-' && !hasMinus && value.length === 0) {
    return true
  }

  if ((key === '.' || key === ',') && value.length > 0 && isDecimal && !hasDot && !hasComma) {
    return true
  }

  return false
}

export const isBelowMinLimit = (value: number, min?: number): boolean => {
  if (min !== undefined && value < min) {
    return true
  }

  return false
}

export const isAboveMaxLimit = (value: number, max?: number): boolean => {
  if (max !== undefined && value > max) {
    return true
  }

  return false
}

/** Round a number to a specified precision */
export const roundToPrecision = (value: number, precision: number): number => {
  if (precision < 0) {
    throw new Error('Precision must not be a negative integer')
  }
  const multiplier = Math.pow(10, precision)
  return Math.round(value * multiplier) / multiplier
}
